import { TWorkflowById } from '@/domains/workflows/fetchers';
import { BlocksVariant } from '@/lib/blocks/variants/BlocksVariant/BlocksVariant';
import { useEntityLogic } from '@/pages/Entity/hooks/useEntityLogic/useEntityLogic';
import { Case } from './components/Case/Case';

export const Entity = () => {
  const { workflow, selectedEntity } = useEntityLogic();

  if (!workflow || !selectedEntity) {
    return null;
  }

  // Selected entity
  return (
    <Case key={workflow.id}>
      {/* Reject and approve header */}
      <Case.Actions
        id={workflow.id}
        entityId={selectedEntity.id}
        fullName={selectedEntity.name}
        showResolutionButtons={
          // Show buttons if workflowLevelResolution is true OR if it's explicitly false (task-level)
          // For task-level resolution, buttons still appear but work at workflow level
          workflow.workflowDefinition?.config?.workflowLevelResolution !== undefined
            ? true // Always show buttons when workflowLevelResolution is configured (true or false)
            : workflow.context?.entity?.type === 'business'
        }
        workflow={workflow as TWorkflowById}
      />
      <Case.Content key={selectedEntity?.id}>
        {workflow.workflowDefinition && (
          <BlocksVariant
            workflowDefinition={{
              version: workflow.workflowDefinition?.version,
              variant: workflow.workflowDefinition?.variant,
              config: workflow.workflowDefinition?.config,
              name: workflow.workflowDefinition?.name,
            }}
          />
        )}
      </Case.Content>
    </Case>
  );
};
